export default abstract class Cryptography {
    public static async generateOauthChallenge(verifier: string): Promise<string> {
        const result: ArrayBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
        const challenge: string = btoa(String.fromCharCode(...new Uint8Array(result)));

        return challenge.replaceAll('=', '').replaceAll('+', '-').replaceAll('/', '_');
    }
}
